import { View, ViewModel } from "binder"
import { PreviewFormViewModel } from "./previewForm-viewModel"
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class PreviewFormView extends View<PreviewFormViewModel>{
    GetViewUniqueId(): string {
        return "V-48ED7DB4-CDC9-4410-9D08-0E6212A65033"
    }
    loadHtml(): string {
        let element = require('./previewForm.html').default;
        let style = require('./previewForm.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set viewModel(v: ViewModel) { this._viewModel = v; } public get viewModel(): ViewModel { return this._viewModel;} private _viewModel: ViewModel;
    public set mainTemplateSelector(v: string) { this._mainTemplateSelector = v; } public get mainTemplateSelector(): string { return this._mainTemplateSelector;} private _mainTemplateSelector: string;
    public set templateSelector(v: ITemplateSelector) { this._templateSelector = v; } public get templateSelector(): ITemplateSelector { return this._templateSelector;} private _templateSelector: ITemplateSelector;


    public set popupTemplateSelector(v: string) { this._popupTemplateSelector = v; } public get popupTemplateSelector(): string { return this._popupTemplateSelector;} private _popupTemplateSelector: string;
    public set popupWidth(v: string) { this._popupWidth = v; } public get popupWidth(): string { return this._popupWidth;} private _popupWidth: string;
    public set popupHeight(v: string) { this._popupHeight = v; } public get popupHeight(): string { return this._popupHeight;} private _popupHeight: string;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    close(){
        this.dataContext.closePopup(false);
    }
}
